import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsLoggedIn } from '@sorare/core/src/hooks/auth/useIsLoggedIn';
import { usePaginatedQuery } from '@sorare/core/src/hooks/graphql/usePaginatedQuery';

import { OfflineLanding } from '#src/components/invite/OfflineLanding/index.tsx';
import { OnlineLanding } from '#src/components/invite/OnlineLanding/index.tsx';

import type {
  ReferralProgramConfig,
  ReferralProgramConfigVariables,
} from './__generated__/page.graphql.ts';

const REFERRAL_PROGRAM_CONFIG = gql`
  query ReferralProgramConfig($after: String, $sport: Sport!) {
    currentUser {
      slug
      ...OnlineLanding_currentUser
    }
    config {
      id
      ...OnlineLanding_config
      ...OfflineLanding_config
    }
  }
  ${OfflineLanding.fragments.config}
  ${OnlineLanding.fragments.config}
  ${OnlineLanding.fragments.currentUser}
` as TypedDocumentNode<ReferralProgramConfig, ReferralProgramConfigVariables>;

const InvitePage = () => {
  const isLoggedIn = useIsLoggedIn();
  const { sport } = useSportContext();

  const { data, loadMore, loading } = usePaginatedQuery(
    REFERRAL_PROGRAM_CONFIG,
    {
      variables: { sport },
      connections: ['ReferralRewardConnection'],
    }
  );

  return isLoggedIn ? (
    <OnlineLanding
      config={data?.config}
      currentUser={data?.currentUser}
      loadMore={loadMore}
      loading={loading}
      sport={sport}
    />
  ) : (
    <OfflineLanding config={data?.config} sport={sport} />
  );
};

export default InvitePage;
